import { http } from "../http-common";

const getProposalReportStats = (startDate?: string, endDate?: string) => {
  return http.get<any>(`/proposals/report/stats?startDate=${startDate}&endDate=${endDate}`);
};

const getProposalSummary = (startDate?: string, endDate?: string) => {
  return http.get<any>(`/proposals/report/summary?startDate=${startDate}&endDate=${endDate}`);
};

const getProposalStatusCounts = (startDate?: string, endDate?: string) => {
  return http.get<any>(`/proposals/report/status-counts?startDate=${startDate}&endDate=${endDate}`);
};

const getProposalStatusCountsTotal = (startDate?: string, endDate?: string) => {
  return http.get<any>(`/proposals/report/status-counts/total?startDate=${startDate}&endDate=${endDate}`);
};

const getMonthlyCustomerCounts = (year?: string | number) => {
  return http.get<any>(`/customers/report/monthly-customer-counts?year=${year}`);
};

const getMonthlyCompanyCounts = (year?: string | number) => {
  return http.get<any>(`/companies/report/monthly-company-counts?year=${year}`);
};

const getMonthlyCompanyCountsTotal = (year?: string | number) => {
  return http.get<any>(`/companies/report/monthly-company-counts-total?year=${year}`);
};


const getCompanyProposalStats = (startDate?: string, endDate?: string) => {
  return http.get<any>(`/companies/report/company-proposal-stats?startDate=${startDate}&endDate=${endDate}`);
};

const ReportService = {
  getProposalReportStats,
  getProposalSummary,
  getProposalStatusCounts,
  getProposalStatusCountsTotal,
  
  getMonthlyCustomerCounts,

  getMonthlyCompanyCounts,
  getMonthlyCompanyCountsTotal,
  getCompanyProposalStats,
};

export default ReportService;
